import { render, staticRenderFns } from "./UplimitReason.vue?vue&type=template&id=5e6faf19"
import script from "./UplimitReason.vue?vue&type=script&lang=js"
export * from "./UplimitReason.vue?vue&type=script&lang=js"
import style0 from "./UplimitReason.vue?vue&type=style&index=0&id=5e6faf19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports